<!-- eslint-disable -->
<template>
  <span style="display: inline-flex">
    <span class="item-name-loading">
      {{C_calculatedNameLabel}}
      <clip-loader v-if="showLoading === true" :loading="DV_isLoading" :color="'black'" :size="'15px'"></clip-loader>
    </span>
  </span>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

/* eslint-disable */
export default {
  name: "c11ObjectNameLabel",
  components: {ClipLoader},
  props: ["showLoading", "objectUid", "isNameNeeded"],
  data() {
    return {
      objectMetaData: {},
      isInitiailized: false,
      DV_isLoading: true
    };
  },
  mounted: function() {
      this.$nextTick(function(){
      this.startListener();
      });
  },
  methods: {
    startListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.vue_instance.$data.watchdog.watchdogDbConnected === true && typeof this.objectUid === 'string') {
        window.G_watchdog_data.initObjectMetaDataListener(this.objectUid);
        this.objectMetaData= window.G_watchdog_data.IV_objects_meta_data;
        this.isInitiailized = true;
      } else {
        setTimeout(this.startListener, 200);
      }
    }
  },
  computed: {
    C_calculatedNameLabel() {
      // human readable name
      if (this.isInitiailized === true && 
          this.objectUid !== null && 
          this.objectUid !== undefined && 
          this.objectUid in this.objectMetaData && 
          this.objectMetaData[this.objectUid] !== null &&
          this.objectMetaData[this.objectUid] !== undefined &&
          'name' in this.objectMetaData[this.objectUid]) {
        this.DV_isLoading = false;
        return this.objectMetaData[this.objectUid]['name'];
      // uid in case we can't look up human readable name
      } else if (
        this.objectUid !== null && this.objectUid !== undefined &&
        this.objectMetaData[this.objectUid] !== null &&
        this.objectMetaData[this.objectUid] !== undefined &&
        ( this.objectUid in this.objectMetaData === false || 
          'name' in this.objectMetaData[this.objectUid] === false )
        ) {
        this.DV_isLoading = true;
        return `Loading: ${this.objectUid}`
      } else {
        this.DV_isLoading = true;
        return "Loading..."
      }
    },
  },
  watch: {
    objectMetaData() {
      if (this.isNameNeeded === undefined || this.isNameNeeded === false) {
        return;
      }
      if (this.objectUid !== null && this.objectUid !== undefined &&
          this.objectUid in this.objectMetaData && 
          'name' in this.objectMetaData[this.objectUid]) {
        var name = this.objectMetaData[this.objectUid]['name'];
        this.$emit("event-object-name-changed", name);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Labels/c11ObjectNameLabel.vue